import React from 'react';
import {
  Box,
  Hint,
  Inscription,
  OutlinedCompleteIcon,
  RoundBlockIcon,
  WarningIcon,
} from '@common-fe/common-fe';

interface Props {
  isVerified?: boolean;
  showWarning?: boolean;
}

const NotVerifiedWarningIcon: React.FC<Pick<Props, 'showWarning'>> = ({ showWarning }) => (
  <Box>
    <Hint
      testId="email-is-not-verified"
      hintAlign="vertical"
      hintWidth="auto"
      hintElement={showWarning ? <WarningIcon color="warning" /> : <RoundBlockIcon color="danger" />}
    >
      <Inscription size="small">
        Email is not verified
      </Inscription>
    </Hint>
  </Box>
);

const ContactVerificationHint: React.FC<Props> = ({ isVerified, showWarning }) => isVerified
  ? <OutlinedCompleteIcon color="success" data-testid="success-icon" />
  : <NotVerifiedWarningIcon showWarning={showWarning} />;

export default ContactVerificationHint;
